import React from 'react';
import { toast } from 'react-toastify';
import { TextareaControl } from '@wordpress/components';
import { notifyError } from '../utils/toast';

const ImportExport = () => {
  const [exporting, setExporting] = React.useState(false);
  const [importing, setImporting] = React.useState(false);
  const [importJson, setImportJson] = React.useState('');

  const handleExport = async () => {
    setExporting(true);

    const formData = new FormData();
    formData.append('action', 'tpwvs_export_settings');
    formData.append('security', tpwvs_admin_settings.update_nonce);

    try {
      const res = await fetch(tpwvs_admin_settings.api_url, {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();

      if ( data && data.success && data.data && data.data.settings ) {
        const content = JSON.stringify( data.data.settings, null, 2 );
        const blob = new Blob([content], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'pwvs-settings.json';
        a.click();
        URL.revokeObjectURL(url);
        toast.success( 'Export ready — download started' );
      } else {
        throw new Error( (data && data.data && data.data.message) ? data.data.message : 'Export failed' );
      }
    } catch ( e ) {
      notifyError( 'Export failed' );
    } finally {
      setExporting(false);
    }
  };

  const handleImportFile = ( e ) => {
    const file = e.target.files && e.target.files[0];
    if ( ! file ) {
      return;
    }

    const reader = new FileReader();
    reader.onload = ( ev ) => {
      setImportJson( ev.target.result );
    };
    reader.readAsText( file );
  };

  const handleImport = async () => {
    if ( ! importJson ) {
      notifyError('Please select a JSON file to import.');
      return;
    }

    let parsed;
    try {
      parsed = JSON.parse( importJson );
    } catch ( e ) {
      notifyError('Invalid JSON file.');
      return;
    }

    setImporting(true);

    const formData = new FormData();
    formData.append('action', 'tpwvs_import_settings');
    formData.append('security', tpwvs_admin_settings.update_nonce);
    formData.append('settings', JSON.stringify(parsed));

    try {
      const res = await fetch(tpwvs_admin_settings.api_url, {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();
      if ( data && data.success ) {
        toast.success( data.data && data.data.message ? data.data.message : 'Import successful' );
      } else {
        throw new Error( (data && data.data && data.data.message) ? data.data.message : 'Import failed' );
      }
    } catch ( e ) {
      notifyError('Import failed');
    } finally {
      setImporting(false);
    }
  };

  return (
    <div className="tpv-import-export-page bg-gray rounded-3xl px-[1rem] sm:px-[1.5rem] md:px-[2.725rem] lg:px-[50px] xl:px-[80px] pb-[62px] py-11 h-full">
      <h3 className="text-2xl font-medium mb-4">Import / Export Settings</h3>

      <div className="mb-6">
        <h4 className="text-lg mb-2">Export</h4>
        <p className="mb-3">Download your current plugin settings as a JSON file.</p>
        <button type="button" className="rounded bg-theme text-white px-3 py-1.5 hover:bg-theme600" onClick={handleExport} disabled={exporting}>{exporting ? 'Exporting...' : 'Export Settings'}</button>
      </div>

      <hr className="my-6" />

      <div className="mb-6">
        <h4 className="text-lg mb-2">Import</h4>
        <p className="mb-3">Upload a JSON file created by Export to restore settings.</p>
        <input type="file" accept="application/json" onChange={handleImportFile} />
        <div className="mt-4">
          <button type="button" className="rounded border border-theme text-theme px-3 py-1.5 hover:bg-theme hover:text-white" onClick={() => setImportJson('')}>Clear</button>
          <button type="button" className="ml-3 rounded bg-theme text-white px-3 py-1.5 hover:bg-theme600" onClick={handleImport} disabled={importing}>{importing ? 'Importing...' : 'Import Settings'}</button>
        </div>
        <div className="mt-4">
          <TextareaControl value={importJson} onChange={(val) => setImportJson(val)} rows={8} />
        </div>
      </div>
    </div>
  );
};

export default ImportExport;
